<template>
  <Table :accounts="accounts" @openEmail="openSingle" :_title="_title" :_emptyListMessage="_emptyListMessage"
         :_loading="_loading" :_searchTerm="_searchTerm"/>
</template>
<script>
import window from "@/mixins/window";
import {mapActions} from "pinia";
import {useEmailStore} from "@/stores/email";
import Table from "@/views/manageApplicants/table.vue";

export default {
  mixins: [window],
  components: {
    Table
  },
  props: {
    accounts: {
      type: Array,
    },
    _title: {
      type: String,
    },
    _emptyListMessage: {
      type: String
    },
    _loading: {
      type: Boolean,
      default: false
    },
    _searchTerm: {
      type: String
    }
  },
  methods: {
    ...mapActions(useEmailStore, ["openSingle"]),
  },
  setup() {
  }
};
</script>
<style lang="scss">
.check-transition-enter-active {
  transition: all 150ms ease-out;
}

.check-transition-leave-active {
  transition: all 0.24s cubic-bezier(1, 0.5, 0.8, 1);
}

.check-transition-enter-from,
.check-transition-leave-to {
  transform: scale(1) translateY(-2px);
  opacity: 0;
}
</style>
